import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import o from "../Color.js";
import { clone as e } from "../core/lang.js";
import { toPt as i } from "../core/screenUtils.js";
import { property as r } from "../core/accessorSupport/decorators/property.js";
import { cast as s } from "../core/accessorSupport/decorators/cast.js";
import { enumeration as n } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as h } from "../core/accessorSupport/decorators/subclass.js";
import { writer as l } from "../core/accessorSupport/decorators/writer.js";
import p from "./Font.js";
import a from "./Symbol.js";

var _d;

var y = _d = /*#__PURE__*/function (_a) {
  _inherits(d, _a);

  var _super = _createSuper(d);

  function d() {
    var _this;

    _classCallCheck(this, d);

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(t)), _this.backgroundColor = null, _this.borderLineColor = null, _this.borderLineSize = null, _this.font = new p(), _this.horizontalAlignment = "center", _this.kerning = !0, _this.haloColor = null, _this.haloSize = null, _this.rightToLeft = null, _this.rotated = !1, _this.text = "", _this.type = "text", _this.verticalAlignment = null, _this.xoffset = 0, _this.yoffset = 0, _this.angle = 0, _this.width = null, _this.lineWidth = 192, _this.lineHeight = 1;
    return _this;
  }

  _createClass(d, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(t, o, e) {
      if (t && "string" != typeof t) return t;
      var i = {};
      return t && (i.text = t), o && (i.font = o), e && (i.color = e), i;
    }
  }, {
    key: "writeLineWidth",
    value: function writeLineWidth(t, o, e, i) {
      i && "string" != typeof i ? i.origin : o[e] = t;
    }
  }, {
    key: "castLineWidth",
    value: function castLineWidth(t) {
      return i(t);
    }
  }, {
    key: "writeLineHeight",
    value: function writeLineHeight(t, o, e, i) {
      i && "string" != typeof i ? i.origin : o[e] = t;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _d({
        angle: this.angle,
        backgroundColor: e(this.backgroundColor),
        borderLineColor: e(this.borderLineColor),
        borderLineSize: this.borderLineSize,
        color: e(this.color),
        font: this.font && this.font.clone(),
        haloColor: e(this.haloColor),
        haloSize: this.haloSize,
        horizontalAlignment: this.horizontalAlignment,
        kerning: this.kerning,
        lineHeight: this.lineHeight,
        lineWidth: this.lineWidth,
        rightToLeft: this.rightToLeft,
        rotated: this.rotated,
        text: this.text,
        verticalAlignment: this.verticalAlignment,
        width: this.width,
        xoffset: this.xoffset,
        yoffset: this.yoffset
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      return "".concat(this.backgroundColor && this.backgroundColor.hash(), ".").concat(this.borderLineColor, ".").concat(this.borderLineSize, ".").concat(this.color.hash(), ".").concat(this.font && this.font.hash(), ".").concat(this.haloColor && this.haloColor.hash(), ".").concat(this.haloSize, ".").concat(this.horizontalAlignment, ".").concat(this.kerning, ".").concat(this.rightToLeft, ".").concat(this.rotated, ".").concat(this.text, ".").concat(this.verticalAlignment, ".").concat(this.width, ".").concat(this.xoffset, ".").concat(this.yoffset, ".").concat(this.lineHeight, ".").concat(this.lineWidth, ".").concat(this.angle);
    }
  }]);

  return d;
}(a);

t([r({
  type: o,
  json: {
    write: !0
  }
})], y.prototype, "backgroundColor", void 0), t([r({
  type: o,
  json: {
    write: !0
  }
})], y.prototype, "borderLineColor", void 0), t([r({
  type: Number,
  json: {
    write: !0
  }
})], y.prototype, "borderLineSize", void 0), t([r({
  type: p,
  json: {
    write: !0
  }
})], y.prototype, "font", void 0), t([r({
  type: ["left", "right", "center", "justify"],
  json: {
    write: !0
  }
})], y.prototype, "horizontalAlignment", void 0), t([r({
  type: Boolean,
  json: {
    write: !0
  }
})], y.prototype, "kerning", void 0), t([r({
  type: o,
  json: {
    write: !0
  }
})], y.prototype, "haloColor", void 0), t([r({
  type: Number,
  cast: i,
  json: {
    write: !0
  }
})], y.prototype, "haloSize", void 0), t([r({
  type: Boolean,
  json: {
    write: !0
  }
})], y.prototype, "rightToLeft", void 0), t([r({
  type: Boolean,
  json: {
    write: !0
  }
})], y.prototype, "rotated", void 0), t([r({
  type: String,
  json: {
    write: !0
  }
})], y.prototype, "text", void 0), t([n({
  esriTS: "text"
}, {
  readOnly: !0
})], y.prototype, "type", void 0), t([r({
  type: ["baseline", "top", "middle", "bottom"],
  json: {
    write: !0
  }
})], y.prototype, "verticalAlignment", void 0), t([r({
  type: Number,
  cast: i,
  json: {
    write: !0
  }
})], y.prototype, "xoffset", void 0), t([r({
  type: Number,
  cast: i,
  json: {
    write: !0
  }
})], y.prototype, "yoffset", void 0), t([r({
  type: Number,
  json: {
    read: function read(t) {
      return t && -1 * t;
    },
    write: function write(t, o) {
      return o.angle = t && -1 * t;
    }
  }
})], y.prototype, "angle", void 0), t([r({
  type: Number,
  json: {
    write: !0
  }
})], y.prototype, "width", void 0), t([r({
  type: Number
})], y.prototype, "lineWidth", void 0), t([l("lineWidth")], y.prototype, "writeLineWidth", null), t([s("lineWidth")], y.prototype, "castLineWidth", null), t([r({
  type: Number
})], y.prototype, "lineHeight", void 0), t([l("lineHeight")], y.prototype, "writeLineHeight", null), y = _d = t([h("esri.symbols.TextSymbol")], y);
var c = y;
export { c as default };